var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonCancellable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17808 2.00015C2.12972 2.00015 2.08756 2.01522 2.05425 2.05108C2.01798 2.08709 2 2.12895 2 2.17402V6.33745C2 6.38253 2.01798 6.42132 2.05425 6.45132C2.08756 6.48133 2.12972 6.4964 2.17808 6.4964H19.936C19.9843 6.4964 20.0265 6.48133 20.0598 6.45132C20.0961 6.42132 20.114 6.38239 20.114 6.33745V2.17388C20.114 2.1288 20.0961 2.08694 20.0598 2.05093C20.0265 2.01508 19.9843 2 19.936 2H2.17808V2.00015ZM3.06256 6.50709C3.02792 6.50709 2.99313 6.52216 2.96305 6.55202C2.93578 6.58202 2.92075 6.61642 2.92075 6.64803V17.9826C2.92075 18.0143 2.93593 18.0486 2.96305 18.0785C2.99313 18.1087 3.02644 18.1205 3.06256 18.1205H19.0513C19.0876 18.1205 19.1209 18.1087 19.151 18.0785C19.1783 18.0486 19.1933 18.0156 19.1933 17.9826V6.64803C19.1933 6.61496 19.1781 6.58202 19.151 6.55202C19.1209 6.52216 19.0863 6.50709 19.0513 6.50709H3.06256ZM8.63273 9.20455H13.4813C13.7411 9.20455 13.9614 9.29441 14.1425 9.47444C14.3266 9.65724 14.4171 9.87606 14.4171 10.1338C14.4171 10.3915 14.3266 10.6134 14.1425 10.8022C13.9613 10.9881 13.7408 11.084 13.4813 11.084H8.63273C8.37313 11.084 8.1526 10.9881 7.97158 10.8022C7.78746 10.6134 7.69695 10.3914 7.69695 10.1338C7.69695 9.87606 7.78746 9.65724 7.97158 9.47444C8.1526 9.29441 8.37299 9.20455 8.63273 9.20455Z",
    stroke: "#D75951",
    strokeWidth: 1.5,
    strokeMiterlimit: 2.6131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonCancellable);
export default __webpack_public_path__ + "static/media/non-cancellable.5c4f4990b87c6ae3a29634ef231e9fa9.svg";
export { ForwardRef as ReactComponent };